import styled from "styled-components";

export const Container = styled.form`
    position: relative;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: white;
    box-shadow: 24;
    padding: 25px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    font-weight: 700;
    outline: none;
`;

export const TitleModal = styled.div`
    font-size: 22px;
    font-weight: bold;
    text-align: center;
`;

export const ContentButtonModal = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e0e0e0;
`;

export const SubTitle = styled.h3`
    font-size: 18px;
    font-weight: 500;
    text-align: center;
`;

export const CustomerDatabaseHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
    margin: 1rem 0 0.5rem;

    .MuiFormControlLabel-root {
        margin: 0;
    }
`;

export const CustomerDatabaseTitle = styled.h3`
    font-size: 18px;
    font-weight: 500;
    margin: 0;
`;

export const Body = styled.div`
    width: 100%;
`;

export const CustomerDatabaseList = styled.div`
    width: 100%;
`;

export const CustomerDatabaseSection = styled.div`
    width: 100%;
    padding-top: ${({ $hasDivider }: { $hasDivider?: boolean }) =>
        $hasDivider ? "0.5rem" : "0"};
`;

export const ContentInput = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 1rem 0;
`;

export const CustomerDatabaseGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
    margin: 0 0 1rem;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 576px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;
